import FAQs from "./components/FAQs";
import Responsive from "./components/Responsive";
import SEO from "../../components/common/SEO";

const index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Youstad Plans & Pricing",
    "description": "Choose the perfect plan for your academy. Flexible pricing options for Ledger, Docket, and Bite management systems.",
    "url": "https://youstad.com/plans",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Ledger Plan",
          "description": "Invoice generation and cash register management"
        },
        {
          "@type": "ListItem", 
          "position": 2,
          "name": "Docket Plan",
          "description": "Timetable creation and schedule management"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Bite Plan", 
          "description": "Canteen and food service management"
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Youstad Plans & Pricing | Choose Your Academy Management Solution"
        description="Choose the perfect plan for your academy. Flexible pricing options for Ledger, Docket, and Bite management systems. Start optimizing your academy operations today."
        keywords="academy plans, pricing, subscription, academy management pricing, educational software plans, school management pricing"
        url="https://youstad.com/plans"
        structuredData={structuredData}
      />
      <Responsive />
      <FAQs />
    </>
  );
};

export default index;
